import { ChatCreditKeyPage } from '@/ChatCreditKey'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/chatCreditKey/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <ChatCreditKeyPage />
}
